<template>
  <div>
    <v-btn :disabled='max_value_allowed.val == 0 ||!enable_button || !canEdit' rounded color="blue-grey"
      class="white--text font-weight-bold" @click="dialog = true">
      <v-icon left>mdi-account-credit-card</v-icon>
      Pagar {{ model_map[model] }}
    </v-btn>

    <v-dialog v-model="dialog" v-if="dialog" scrollable max-width="500px" transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Pagar motorista</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="newPaymentForm" lazy-validation>
            <v-col cols="12" v-if="paymentKindOptions.length">
              <v-subheader class="px-0">Forma de pagamento</v-subheader>
              <v-chip-group
                v-model="payment.current_desination_receipt_kind"
                mandatory
                active-class="payment-kind-chip--active"
                class="payment-kind-chips"
              >
                <v-chip
                  v-for="option in paymentKindOptions"
                  :key="option.value"
                  :value="option.value"
                  pill
                  small
                  class="payment-kind-chip"
                >
                  <v-icon left small>{{ option.icon }}</v-icon>
                  {{ option.label }}
                </v-chip>
              </v-chip-group>
              <div v-if="selectedPaymentKind === 'pix' && receiptConfig.pix_key" class="caption grey--text text--darken-1 mt-2">
                Chave PIX ({{ pixKeyKindLabel }}): <b>{{ receiptConfig.pix_key }}</b>
              </div>
              <div v-if="selectedPaymentKind === 'deposit'" class="caption grey--text text--darken-1 mt-2">
                O pagamento será registrado como depósito bancário.
              </div>
            </v-col>
            <v-col cols="12" v-else>
              <v-alert type="warning" dense text>
                Este motorista não possui forma de recebimento cadastrada.
              </v-alert>
            </v-col>

            <v-col cols='11'>
              <v-subheader>Informe o valor a ser pago (valor máximo: {{ max_value_allowed.val_string }})</v-subheader>
              <v-text-field :rules="[rules.required, rules.notZero]" v-money="money" v-model="payment.value_aux"
                prepend-icon="mdi-currency-usd" label="Valor" prefix="R$"
              ></v-text-field>
            </v-col>

            <v-col cols='11' v-if="!payment_value_allowed">
              <v-alert type="error" :value="true">
                Valor acima do máximo devido/permitido.
              </v-alert>
            </v-col>

            <v-col cols='11' class="mt-2">
              <v-textarea v-model="payment.comment" label="Comentários" prepend-icon="mdi-comment" rows="2">
              </v-textarea>
            </v-col>
            <FileAttachment ref="attach" is_creating :update_infos="{API: 'InternalPayment',MODEL:'internal_payment', id: '-1'}"></FileAttachment>
          </v-form>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn small text @click="reloadPayment" color="error">Cancelar</v-btn>
          <v-btn small @click="submitNewPayment" :disabled="!canSubmit" color="success">Pagar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading" loadingText='Salvando'></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { VMoney } from 'v-money'
import Api from '@/api/index';

export default {
  name: "PayDriver",
  directives: { money: VMoney },
  components: {
    AttachDoc: () => import('@/_backoffice/_financial/components/shipping/driver/AttachDoc.vue'),
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
  },
  props: {
    model:{
      type: String,
      default: "Driver",
    },
    max_value_allowed: {
      type: Object,
      default: () => { return { val: 0, val_string: 'R$ 0,00' } }
    },
    modality_id: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
      rules: {
        required: v => !!v || 'Campo é necessário',
        notZero: v => v != '0.00' || 'Não pode ser zero',
      },
      payment: {
        destinable_type: this.model,
        destinable_id: null,
        value_aux: '0.00',
        value: '0.00',
        comment: '',
        current_desination_receipt_kind: null,
      },
      payment_map: {
        cash: 'Dinheiro',
        deposit: 'Depósito',
        pix: 'Pix',
        bill: 'Boleto',
      },
      payment_icon_map: {
        cash: 'mdi-cash',
        deposit: 'mdi-bank',
        pix: 'mdi-qrcode',
        bill: 'mdi-barcode',
      },
      pix_key_kind_map: {
        cnpj: 'CNPJ',
        email: 'E-mail',
        phone: 'Telefone',
        random: 'Aleatória',
      },
      model_map:{
        "Driver" : "Particular",
      }
    }
  },
  computed: {
    payment_value_allowed() {
      let allowed = true
      if (this.max_value_allowed && this.payment.value_aux) {
        let v = this.payment.value_aux.replace(/,/g, '')
        allowed = Number(v) <= this.max_value_allowed.val
      }
      return allowed
    },
    receiptConfig() {
      const attrs = this.oneDriver?.data?.attributes
      if (!attrs) return {}
      if (this.model === 'Driver') {
        return attrs.receipt_config || {}
      }
      return attrs.transporter_receipt_config || attrs.receipt_config || {}
    },
    hasBankAccount() {
      const attrs = this.oneDriver?.data?.attributes
      if (!attrs) return false
      if (!Object.prototype.hasOwnProperty.call(attrs, 'accounts') || attrs.accounts == null) {
        return true
      }
      const accounts = attrs.accounts?.data || (Array.isArray(attrs.accounts) ? attrs.accounts : [])
      return accounts.some(acc => {
        const a = acc.attributes || acc
        return !!(a.agency || a.number)
      })
    },
    paymentKindOptions() {
      const kinds = this.receiptConfig.kinds?.length
        ? this.receiptConfig.kinds
        : (this.receiptConfig.kind ? [this.receiptConfig.kind] : [])

      return kinds
        .filter(kind => kind !== 'deposit' || this.hasBankAccount)
        .map(kind => ({
          value: kind,
          label: this.payment_map[kind] || kind,
          icon: this.payment_icon_map[kind] || 'mdi-cash',
        }))
    },
    selectedPaymentKind() {
      return this.payment.current_desination_receipt_kind
    },
    pixKeyKindLabel() {
      return this.pix_key_kind_map[this.receiptConfig.pix_key_kind] || this.receiptConfig.pix_key_kind
    },
    canSubmit() {
      if (this.selectedPaymentKind === 'deposit' && !this.hasBankAccount) return false
      return this.payment_value_allowed && !!this.payment.current_desination_receipt_kind
    },
    enable_button() {
      return this.oneDriver && (this.oneDriver.open_incomes || (this.oneDriver.data && this.oneDriver.data.attributes.open_incomes))
    },
    canEdit() {
      return this.isManager() || this.isFinancial() || this.isDirector() || this.isLogistics() || this.isSalesExecutive()
    },
    ...mapState({
      oneDriver: state => state.Driver.oneDriver,
    })
  },
  methods: {
    initPaymentKind() {
      const firstKind = this.paymentKindOptions[0]?.value || null
      this.payment.current_desination_receipt_kind = firstKind
    },
    submitNewPayment() {
      if (this.$refs.newPaymentForm.validate()) {
        let conf = confirm('Criar novo pagamento para motorista?')
        if (conf) {
          this.createPayment()
        }
      }
    },
    prepareInternalPayment(){
      this.payment.destinable_type = this.model
      this.payment.destinable_id = this.oneDriver.data.id
      this.payment.value = this.payment.value_aux.replace(/,/g, '')
      this.payment.modality_id = this.modality_id
    },
    createPayment() {
      this.loading = true
      this.prepareInternalPayment()
      let METHOD = this.model == "Driver" ? "create" : "createWithDriverId"
      Api.InternalPayment[METHOD](this.payment, this.oneDriver.data.id).then(r => r.data).then(r => {
        let id = r.internal_payment.id
        this.addNotification({type: 'success', msg: 'Pago com sucesso'})
        this.$refs.attach.updateFile(id)
        this.$emit('payed')
      }).catch(err => {
        if (err.response.data) {
          msg = err.response.data.errors.join(', ')
        }
        this.addNotification({type: 'error', msg: msg})
      }).finally(() => {
        this.loading = false
        this.reloadPayment()
      })
    },
    reloadPayment() {
      this.dialog = false
      this.payment = {
        destinable_type: this.model,
        destinable_id: null,
        value_aux: '0.00',
        value: '0.00',
        comment: '',
        current_desination_receipt_kind: null,
      }
      this.$emit('payed')
    },
  },
  watch: {
    dialog(nv) {
      if (nv) {
        this.initPaymentKind()
      } else {
        this.reloadPayment()
      }
    },
    model(){
      this.payment.destinable_type = this.model
    }
  },
}
</script>

<style scoped>
.payment-kind-chips {
  justify-content: flex-start;
}

.payment-kind-chip {
  background-color: #f0f0f0 !important;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.payment-kind-chip--active {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #fff !important;
}

.payment-kind-chip--active >>> .v-icon {
  color: #fff !important;
}
</style>
